/**
 * Promisified timeout that awaits for provided amount of millis.
 *
 * @param millis - milliseconds to wait
 * @returns resolving promise after set amount of time
 */
export function forMillis(millis: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, millis));
}

/**
 * Promisified timeout that awaits for next async queue (0 ms).
 *
 @returns resolving promise after 0 ms
 */
export function nextAsyncQueue(): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, 0));
}
